let get_selected_row_ids = (dt) => {
    let ids = [];
    let selectedRows = dt.rows('.selected').data();

    $.each(selectedRows, function (index, val) {
        ids.push(val.id)
    });

    return ids;
};

export default get_selected_row_ids;
